import { KeyAndScale } from '@arpeggi/shared'
import { FC, useEffect, useState } from 'react'
import { IArpMedia } from '../../../../features/arp-registry/ArpMedia'
import ArpRegistry from '../../../../features/arp-registry/ArpRegistry'
import { formatEpochTimestamp } from '../../core/helpers/dates'
import {
  CurrentlyPlayingMediaInfo,
  InfoRow,
  ProfileCurrentlyPlayingTabs
} from './ProfileCurrentlyPlaying'

interface Props {
  sample: IArpMedia
}

const CurrentlyPlayingSampleProperties: FC<Props> = ({ sample }) => {
  const createTime = sample?.createdAt && parseInt(sample.createdAt)
  const keyAndScale = new KeyAndScale()
  keyAndScale.fromInt(sample.metadata.key)
  return (
    <>
      {sample.metadata.bpm !== 0 && <InfoRow title="Original BPM">{sample.metadata.bpm}</InfoRow>}
      {sample.metadata.genres[0] && <InfoRow title="Genre">{sample.metadata.genres[0]}</InfoRow>}
      <InfoRow title="Key">{keyAndScale.displayName()}</InfoRow>
      <InfoRow title="Mint Date">{formatEpochTimestamp(createTime)}</InfoRow>
    </>
  )
}

const CurrentlyPlayingSampleOverview: FC<Props> = ({ sample }) => {
  return (
    <>
      <InfoRow title="Artist">{sample?.user.displayName}</InfoRow>
      <InfoRow title="Contract Address">{sample?.contractAddress}</InfoRow>
      <InfoRow title="Token ID">{sample?.tokenId}</InfoRow>
      <InfoRow title="Blockchain">Polygon</InfoRow>
    </>
  )
}

const CurrentlyPlayingSampleInfo: FC<CurrentlyPlayingMediaInfo> = ({ tab, index }) => {
  const [sample, setSample] = useState<IArpMedia>(null)

  useEffect(() => {
    ArpRegistry.getByIdAsync(index).then((data) => setSample(data))
  }, [index])

  return (
    <>
      {tab === ProfileCurrentlyPlayingTabs.OVERVIEW && sample && (
        <CurrentlyPlayingSampleOverview sample={sample} />
      )}
      {tab === ProfileCurrentlyPlayingTabs.PROPERTIES && sample && (
        <CurrentlyPlayingSampleProperties sample={sample} />
      )}
    </>
  )
}

export default CurrentlyPlayingSampleInfo
